<template>
    <div class="modal-overlay" ref="panel">
        <div class="modal-content max-width-800">
            <div class="panel-title">
                <div>
                    <i :class="getFeatureIcons('management')"></i>
                    <span> {{ getFeatureNames('management') }} - {{ this.symbol }}</span>
                </div>
                <span @click="closePanel"><i class="cursor-pointer ti-close right-side-toggle medium-icon"></i></span>
            </div>
            <div class="card card-body modal-body mt-2">
                <div class="tab-pane">
                    <loading-container :loading="form.getShareholderLoading">
                        <table class="table table-bordered compare-stock-table sticky-table">
                            <thead>
                                <tr vertical-align="baseline">
                                    <th style="vertical-align: top">Tên</th>
                                    <th class="th-sort"
                                        @click="onSortField('roe')">
                                        Chức vụ
                                    </th>
                                    <th class="th-sort"
                                        @click="onSortField('pe')">
                                        Cổ phiếu sở hữu
                                    </th>
                                    <th class="th-sort"
                                        @click="onSortField('dividend')">
                                        Phân trăm sở hữu (%)
                                    </th>
                                    <th class="th-sort"
                                        @click="onSortField('mos')">
                                        Ngày thông tin
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in shareholders.items" :key="index"
                                    :class="index === 0 ? 'bg-gray' : ''">
                                    <td>
                                        {{ item.name }}
                                    </td>
                                    <td>
                                        {{ item.role }}
                                    </td>
                                    <td>
                                        {{ item.shares | numberDisplay }}
                                    </td>
                                    <td>
                                        {{ item.percentage }}
                                    </td>
                                    <td>
                                        {{ item.info_date }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </loading-container>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoadingContainer from "@/components/Misc/LoadingContainer";
import common from "@/libs/common";
import FormButton from '@/components/Form/FormButton';
import Breadcrumb from "@/components/Common/Breadcrumb";

export default {
    components: {
        Breadcrumb,
        LoadingContainer,
        FormButton
    },
    props: {
        symbol: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        };
    },
    beforeMount() {
        this.getShareholders(this.symbol);
    },
    computed: {
        ...mapGetters({
            form: "stock/form",
            sort: "stock/sort",
            shareholders: "stock/shareholders",
        }),
    },
    methods: {
        ...mapActions({
            setDefaultCode: "configuration/setDefaultCode",
            getShareholders: "stock/getShareholders",
            setSortField: "stock/setSortField",
        }),
        getFeatureIcons(name) {
            return common.getFeatureIcons(name);
        },
        getFeatureNames(name) {
            return common.getFeatureNames(name);
        },
        valueFilter(value, isDca) {
            if (isDca) {
                return _.round(value, 1);
            }
            return _.round(value * 100, 1) + '%';
        },
        onSortField(sortField) {
            if (sortField === this.sort.field) {
                this.setSortField({ key: 'order', value: this.sort.order === 'asc' ? 'desc' : 'asc' });
            }
            this.setSortField({ key: 'field', value: sortField });
            this.getCompetitors(this.symbol);
        },
        closePanel() {
            this.$emit('close');
        }
    },
}
</script>

<style>
.header-row {
    display: flex;
    gap: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.th-sort {
    position: relative;
    vertical-align: top;
    cursor: pointer;
}

.descending:after {
    content: "\2193";
}

.ascending:after {
    content: "\2191";
}

.ascending:after,
.descending:after {
    display: inline-block;
}

@media only screen and (max-width: 768px) {

    table.compare-stock-table th,
    table.compare-stock-table td {
        font-size: 12px;
        padding: 10px;
    }
}

@media only screen and (max-width: 500px) {

    table.compare-stock-table th,
    table.compare-stock-table td {
        font-size: 10px;
        padding: 2px;
    }
}
</style>